import { Click, ClickType, ElementType } from '@fiverr-private/bianka_js';
import { ClickedBriefElement } from '@fiverr-private/bianka_js/protobuf/bianka/event/activity/v2/extension/dynamic_matches/clicked_brief_element';
import { getContext } from '@fiverr-private/fiverr_context';
import { bianka } from '@fiverr-private/obs';
import { BriefItem } from '../../../lib/types/brief';

const CLICK_EVENT_TYPE = 'clicked_element_briefs_lobby';

export const reportButtonClick = async (name: string, brief?: any) => reportClick(name, ElementType.BUTTON, brief);

export const reportBriefCardClick = async (name: string, brief: any) => reportClick(name, ElementType.CARD, brief);

const reportClick = async (name: string, elementType: ElementType, brief?: BriefItem) => {
    const { pageCtxId, organizationId } = getContext();

    bianka.reportActivity<Click>({
        type: Click,
        event: {
            type: CLICK_EVENT_TYPE,
            clickType: ClickType.LEFT,
            element: {
                name,
                type: elementType,
            },
            page: { name: 'briefs_lobby', ctxId: pageCtxId },
            ...(organizationId && { organization: { id: organizationId } }),
        },
        additionalData: {
            type: ClickedBriefElement,
            message: {
                ...(brief && {
                    briefId: brief.id,
                    briefDisplayedStatus: brief.briefDisplayStatus,
                }),
            },
        },
    });
};
